import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";
import Select from 'react-select'
import * as XLSX from "xlsx";
import DownloadTemplateProjectUrl from "../../download/generate_masterurl_project_import.xlsx";
import DownloadTemplatePromotionUrl from "../../download/generate_masterurl_promotion_import.xlsx";

export default function GenerateMasterURLImport() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'นำเข้าระบบ & ดาวน์โหลด';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [buttonText, setButtonText] = React.useState(btnTextDefault);
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [projectType, setProjectType] = React.useState(null);
    let [buType, setBuType] = React.useState(null);
    let [campaignType, setCampaignType] = React.useState(null);
    let [agency, setAgency] = React.useState(null);
    let [platform, setPlatform] = React.useState(null);
    let [masterUrlFor, setMasterUrlFor] = React.useState(null);
    let [masterUrlForId, setMasterUrlForId] = React.useState(null);

    let [masterUrl, setMasterUrl] = React.useState(null);

    let [generateTypeCampaign, setGenerateTypeCampaign] = React.useState(false);
    let [generateTypeAdsSet, setGenerateTypeAdsSet] = React.useState(false);
    let [generateTypeUTM, setGenerateTypeUTM] = React.useState(false);

    React.useEffect(() => {
        (async function() {
            try {
                setGenerateTypeCampaign(true);

                const resMasterUrlFor = await Utils.getMasterURLFor();
                setMasterUrlFor(resMasterUrlFor);

                const resMasterURL = await Utils.getMasterUrl();
                setMasterUrl(resMasterURL);

                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                const resBuType = await Utils.getBuType();
                setBuType(resBuType);

                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);

                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                setAgency(newAgencies);

                //-- UTM
                await utmDetail();

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onChangeMasterUrlFor = async (obj) => {
        setMasterUrlForId(obj);

        //-- Campaign
        await campaignDetail(obj);

        //-- AdsSet
        await adssetDetail(obj);
    };

    const onCreate = async () => {

        let campaignParams = [];
        let generateTypeCampaignValidate = {};
        if(generateTypeCampaign && generateGroupCampaign.length > 0) {
            if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROJECT) {
                for(let n = 0; n < generateGroupCampaign.length; n++) {
                    campaignParams[n] = [];
                    for (let m = 0; m < excelDataAll.length; m++) {
                        campaignParams[n][m] = [];
                        let rs = excelDataAll[m];
                        let param = await getCampaignParamsProject(n, m, {
                            slug: rs.lang.data + '-' + rs.projectType.data + '-' + rs.apData.slug,
                            projectId: rs.projectCode.data,
                            campaignId: rs.campaignId.data
                        });
                        if (param.params.length > 200) {
                            generateTypeCampaignValidate.message = 'Campaign Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (m+1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                            break;
                        }
                        else {
                            campaignParams[n][m] = param;
                        }
                    }
                }
            }
            else if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROMOTION) {
                for(let n = 0; n < generateGroupCampaign.length; n++) {
                    campaignParams[n] = [];
                    for (let m = 0; m < excelDataAll.length; m++) {
                        campaignParams[n][m] = [];
                        let rs = excelDataAll[m];
                        let param = await getCampaignParamsPromotion(n, m, {
                            slug: rs.apData.slug,
                            campaignId: rs.campaignId.data
                        });
                        if (param.params.length > 200) {
                            generateTypeCampaignValidate.message = 'Campaign Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (m+1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                            break;
                        }
                        else {
                            campaignParams[n][m] = param;
                        }
                    }
                }
            }
        }

        let adssetParams = [];
        let generateTypeAdsSetValidate = {};
        if(generateGroupCampaign !== null && generateGroupCampaign.length > 0) {
            if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROJECT) {
                for(let n = 0; n < generateGroupCampaign.length; n++) {
                    adssetParams[n] = [];
                    for (let m = 0; m < excelDataAll.length; m++) {
                        adssetParams[n][m] = [];
                        for (let idx = 0; idx < generateGroupCampaign[n].masterAdssetItems.length; idx++) {
                            adssetParams[n][m][idx] = [];
                            const param = await getAdssetParamsProject(n, m, idx);
                            if (param.params.length > 200) {
                                generateTypeAdsSetValidate.message = 'Ads Set Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (m+1) + '/' + (idx+1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                                break;
                            }
                            else {
                                adssetParams[n][m][idx] = param;
                            }
                        }
                    }
                }
            }
            else if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROMOTION) {
                for(let n = 0; n < generateGroupCampaign.length; n++) {
                    adssetParams[n] = [];
                    for (let m = 0; m < excelDataAll.length; m++) {
                        adssetParams[n][m] = [];
                        for (let idx = 0; idx < generateGroupCampaign[n].masterAdssetItems.length; idx++) {
                            adssetParams[n][m][idx] = [];
                            const param = await getAdssetParamsPromotion(n, m, idx);
                            if (param.params.length > 200) {
                                generateTypeAdsSetValidate.message = 'Ads Set Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (m+1) + '/' + (idx+1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                                break;
                            }
                            else {
                                adssetParams[n][m][idx] = param;
                            }
                        }
                    }
                }
            }
        }

        let utmParams = [];
        let generateTypeUTMValidate = {};
        if(generateTypeUTM) {
            setLoading(true);
            setButtonText('กำลังตรวจสอบ UTM...');
            if(generateGroupCampaign !== null && generateGroupCampaign.length > 0) {
                for(let n = 0; n < generateGroupCampaign.length; n++) {
                    utmParams[n] = [];
                    for (let m = 0; m < excelDataAll.length; m++) {
                        utmParams[n][m] = [];
                        let excelRow = excelDataAll[m];
                        for (let idx = 0; idx < generateGroupCampaign[n].masterUtmItems.length; idx++) {
                            utmParams[n][m][idx] = [];
                            let sourceTypeIds = [];
                            let itemSource = generateGroupCampaign[n].masterUtmItems[idx].masterUtmItems;
                            let masterUtmItems = generateGroupCampaign[n].masterUtmItems[idx];

                            let params = masterUtmItems.utmPrevewParams;
                            params = params.replace('{campaignId}', excelRow.campaignId.data);
                            params = params.replace('{campaignName}', excelRow.campaignName.data);
                            params = params.replace('{projectId}', excelRow.projectCode.data);
                            params = params.replace('{projectName}', excelRow.projectCode.title);
                            params = params.replace('{projectSlug}', excelRow.apData.slug);
                            params = params.replace('{lineOAUrl}', excelRow.projectCode.lineOAID);
                            params = params.replace('{promotionSlug}', excelRow.apData.slug);

                            let templateRow = utmTemplate.filter(e => e.id === masterUtmItems.utmTemplateId)[0];
                            const templateSource = await Utils.getTemplateSourceById(templateRow.id);
                            const utm = await Utils.getUtmByIds(templateSource);

                            if(utm) {
                                for(let row of utm) {
                                    for(let rs of templateSource) {
                                        let sourceType = rs.source.sourceType;
                                        if(rs.source && rs.utmId === row.id) {
                                            let utmSourceTypeId = 0;
                                            let utmSourceId = rs.id;
                                            let utmSourceTypeText = null;
                                            let inputType = rs.source.inputType;
                                            if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                                utmSourceTypeText = excelRow.campaignId.data;
                                            }
                                            else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                                utmSourceTypeText = excelRow.campaignName.data;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                                utmSourceTypeText = excelRow.projectCode.data;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                                utmSourceTypeText = excelRow.projectCode.title;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                utmSourceTypeText = excelRow.apData.slug;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                                utmSourceTypeText = excelRow.apData.slug;
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                // --
                                            }
                                            else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                                utmSourceTypeText = excelRow.projectCode.lineOAID;
                                            }
                                            else {
                                                let find = sourceType.find(rs => {
                                                    return itemSource.find(it => {
                                                        if(parseInt(it.utmSourceTypeId) === parseInt(rs.id)) {
                                                            return it;
                                                        }
                                                    });
                                                });
                                                if(find) {
                                                    utmSourceId = find.utmSourceId;
                                                    utmSourceTypeId = find.id;
                                                    utmSourceTypeText = find.name;
                                                }
                                            }

                                            sourceTypeIds.push({
                                                utmSourceId: utmSourceId,
                                                utmSourceTypeId: utmSourceTypeId,
                                                utmSourceTypeText: utmSourceTypeText,
                                                inputType: inputType
                                            });
                                        }
                                    }
                                }
                            }

                            utmParams[n][m][idx] = {
                                ids: sourceTypeIds,
                                param: params
                            };
                        }
                    }
                }
            }
        }

        if(generateTypeCampaignValidate.message) {
            setLoading(false);
            setButtonText(btnTextDefault);
            toast.error(generateTypeCampaignValidate.message);
        }
        else if(generateTypeAdsSetValidate.message) {
            setLoading(false);
            setButtonText(btnTextDefault);
            toast.error(generateTypeAdsSetValidate.message);
        }
        else if(generateTypeUTMValidate.message) {
            setLoading(false);
            setButtonText(btnTextDefault);
            toast.error(generateTypeUTMValidate.message);
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROJECT) {
                                await createProject(campaignParams, adssetParams, utmParams);
                            }
                            else if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROMOTION) {
                                await createPromotion(campaignParams, adssetParams, utmParams);
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {
                            setLoading(false);
                            setButtonText(btnTextDefault);
                        }
                    }
                ]
            });
        }
    };

    async function createProject(campaignParams, adssetParams, utmParams) {
        setLoading(true);
        setButtonText(btnTextLoading);

        let url = '';
        let bulkBody = [];

        for (let n = 0; n < generateGroupCampaign.length; n++) {
            for (let m = 0; m < excelDataAll.length; m++) {
                let rs = excelDataAll[m];
                let url = rs.apData.url;
                for (let idx = 0; idx < generateGroupCampaign[n].masterUtmItems.length; idx++) {
                    let masterUtmItems = generateGroupCampaign[n].masterUtmItems[idx];
                    let body = {
                        campaignTemplateId: null,
                        typeId: Utils.GENERATE_TYPE_MASTER_URL,
                        lang: rs.lang.data ?? null,
                        projectTypeId: rs.projectType.data ?? null,
                        projectId: rs.projectCode.data ?? null,
                        campaignDate: rs.campaignDate && rs.campaignDate.data ? new Date(rs.campaignDate.data) : null,
                        campaignId: rs.campaignId && rs.campaignId.data ? rs.campaignId.data : null,
                        agencyId: generateGroupCampaign[n].agencyId,
                        adsPlatformId: generateGroupCampaign[n].adsPlatformId ?? null,
                        masterUrlId: rs.masterUrl.data,
                        masterUrlFor: masterUrlForId ? masterUrlForId.id : null,
                        generateGroupCampaignId: generateGroupCampaign[n].id,
                        url: url,
                        createdBy: userId,
                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                    };

                    if (generateTypeCampaign) {
                        body.generateTypeCampaign = 1;
                        body.paramsCampaign = campaignParams[n][m].params;
                        body.campaignSourceTypeIds = campaignParams[n][m].data;
                    }

                    if (generateTypeAdsSet) {
                        body.generateTypeAdsset = 1;
                        body.paramsAdsset = adssetParams[n][m][idx].params;
                        body.adssetSourceTypeIds = adssetParams[n][m][idx].data;

                        let adsNamingSetNameTypeId = null;
                        if (generateGroupCampaign[n].masterAdssetItems[idx]) {
                            adsNamingSetNameTypeId = masterUtmItems.adsNamingSetNameTypeId;
                        }
                        body.adsNamingSetNameTypeId = adsNamingSetNameTypeId;
                    }

                    if (generateTypeUTM) {
                        //Main URL
                        url = url.toString().trim();

                        let hashtagText = '';
                        if(masterUtmItems.hashtag) {
                            hashtagText = hashtagList.filter(e => e.id === masterUtmItems.hashtag)[0].name;
                        }

                        //Create Params
                        let params = utmParams[n][m][idx].param;
                        params = params + (hashtagText ? '#' + hashtagText : '');
                        let urlParam = url + '?' + params;

                        //Create Short URL (Rebrandly)
                        let rebrandlyUrl = null;
                        if (urlParam && rebrandlyChecked) {
                            const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                            rebrandlyUrl = resShortUrl.shortUrl;
                            //rebrandlyUrl = 'rebrandlyUrl-XXX';
                        }

                        //Create Short URL (Short.IO)
                        let shortioUrl = null;
                        if (urlParam && shortioChecked) {
                            const resShortUrl = await Utils.createShortioShortURL(urlParam);
                            shortioUrl = resShortUrl.path;
                            //shortioUrl = 'shortioUrl-XXX';
                        }

                        body.generateTypeUTM = 1;
                        body.paramsUTM = params;
                        body.utmTemplateId =  masterUtmItems.utmTemplateId;
                        body.utmGroupId = null;
                        body.utmGroupItemId = null;
                        body.hashtag = hashtagText ? hashtagText : null;
                        body.shortUrl = rebrandlyUrl;
                        body.shortioUrl = shortioUrl;
                        body.utmSourceTypeIds = utmParams[n][m][idx].ids;
                    }

                    bulkBody.push(body);
                }
            }
        }

        fetch(Config.url.API_URL + '/api/generate/createBulks', {
            method: 'POST',
            body: JSON.stringify(bulkBody),
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            }
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(async result => {
            if (result) {
                await exportExcelProject(bulkBody);
                toast.success("บันทึกข้อมูลเรียบร้อย");
                setTimeout(function () {
                    navigate('/generateMasterURL', {replace: true});
                }, 1500);
            }
            else {
                setLoading(false);
            }
        }).catch(err => {
            toast.error(err.message);
        });
    }

    async function exportExcelProject(rows) {
        let jsonData = [];
        rows.map(row => {
            let utmUrl = '';
            let campaignUrl = '';
            let adssetUrl = '';
            if(row.generateTypeUTM) {
                utmUrl = row.url + '?' + row.paramsUTM + (row.addLine ? '#addline':'');
            }
            if(row.generateTypeCampaign) {
                campaignUrl = row.paramsCampaign;
            }
            if(row.generateTypeAdsset) {
                adssetUrl = row.paramsAdsset;
            }

            let objective = campaignUrl ? campaignUrl.split('|')[2] : '-';
            let target_type = adssetUrl ? adssetUrl.split('|')[2] : '-';

            jsonData.push({
                Type: Utils.generateUTMType(row.typeId),
                Lang: row.lang,
                ProjectType: row.projectTypeId,
                ProjectCode: row.projectId,
                CampaignID: row.campaignId,
                CampaignDate: row.campaignDate ? new Date(row.campaignDate) : '',
                Objective: objective.split('_')[4],
                TargetType: target_type.split('_')[0],
                CampaignNaming: campaignUrl,
                AdsetNaming: adssetUrl,
                UTM: utmUrl,
                REBRADLY_URL: row.shortUrl ?? '',
                SHORT_IO_URL: row.shortioUrl && shortio.domain ? "https://" + shortio.domain + '/' + row.shortioUrl : '',
                CREATED_BY: roles.loginName,
                CREATED_DATE: Utils.dateYMDHI(new Date())
            });
        });
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "generate_masterurl_project_export_" + Utils.getDate() + ".xlsx");
    }

    async function createPromotion(campaignParams, adssetParams, utmParams) {
        setLoading(true);
        setButtonText(btnTextLoading);

        let url = '';
        let bulkBody = [];

        for (let n = 0; n < generateGroupCampaign.length; n++) {
            for (let m = 0; m < excelDataAll.length; m++) {
                let rs = excelDataAll[m];
                let url = rs.apData.url;
                for (let idx = 0; idx < generateGroupCampaign[n].masterUtmItems.length; idx++) {
                    let masterUtmItems = generateGroupCampaign[n].masterUtmItems[idx];
                    let body = {
                        campaignTemplateId: null,
                        typeId: Utils.GENERATE_TYPE_MASTER_URL,
                        lang: rs.lang.data ?? null,
                        campaignTypeId: rs.campaignType.data ?? null,
                        buTypeId: rs.buType.data ?? null,
                        campaignDate: rs.campaignDate && rs.campaignDate.data ? new Date(rs.campaignDate.data) : null,
                        campaignId: rs.campaignId && rs.campaignId.data ? rs.campaignId.data : null,
                        agencyId: generateGroupCampaign[n].agencyId,
                        adsPlatformId: generateGroupCampaign[n].adsPlatformId ?? null,
                        masterUrlId: rs.masterUrl.data,
                        masterUrlFor: masterUrlForId ? masterUrlForId.id : null,
                        generateGroupCampaignId: generateGroupCampaign[n].id,
                        url: url,
                        createdBy: userId,
                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                    };

                    if (generateTypeCampaign) {
                        body.generateTypeCampaign = 1;
                        body.paramsCampaign = campaignParams[n][m].params;
                        body.campaignSourceTypeIds = campaignParams[n][m].data;
                    }

                    if (generateTypeAdsSet) {
                        body.generateTypeAdsset = 1;
                        body.paramsAdsset = adssetParams[n][m][idx].params;
                        body.adssetSourceTypeIds = adssetParams[n][m][idx].data;

                        let adsNamingSetNameTypeId = null;
                        if (generateGroupCampaign[n].masterAdssetItems[idx]) {
                            adsNamingSetNameTypeId = masterUtmItems.adsNamingSetNameTypeId;
                        }
                        body.adsNamingSetNameTypeId = adsNamingSetNameTypeId;
                    }

                    if (generateTypeUTM) {
                        //Main URL
                        url = url.toString().trim();

                        let hashtagText = '';
                        if(masterUtmItems.hashtag) {
                            hashtagText = hashtagList.filter(e => e.id === masterUtmItems.hashtag)[0].name;
                        }

                        //Create Params
                        let params = utmParams[n][m][idx].param;
                        params = params + (hashtagText ? '#' + hashtagText : '');
                        let urlParam = url + '?' + params;

                        //Create Short URL (Rebrandly)
                        let rebrandlyUrl = null;
                        if (urlParam && rebrandlyChecked) {
                            const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                            rebrandlyUrl = resShortUrl.shortUrl;
                            //rebrandlyUrl = 'rebrandlyUrl-XXX';
                        }

                        //Create Short URL (Short.IO)
                        let shortioUrl = null;
                        if (urlParam && shortioChecked) {
                            const resShortUrl = await Utils.createShortioShortURL(urlParam);
                            shortioUrl = resShortUrl.path;
                            //shortioUrl = 'shortioUrl-XXX';
                        }

                        body.generateTypeUTM = 1;
                        body.paramsUTM = params;
                        body.utmTemplateId =  masterUtmItems.utmTemplateId;
                        body.utmGroupId = null;
                        body.utmGroupItemId = null;
                        body.hashtag = hashtagText ? hashtagText : null;
                        body.shortUrl = rebrandlyUrl;
                        body.shortioUrl = shortioUrl;
                        body.utmSourceTypeIds = utmParams[n][m][idx].ids;
                    }

                    bulkBody.push(body);
                }
            }
        }

        fetch(Config.url.API_URL + '/api/generate/createBulks', {
            method: 'POST',
            body: JSON.stringify(bulkBody),
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            }
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(async result => {
            if (result) {
                await exportExcelPromotion(bulkBody);
                toast.success("บันทึกข้อมูลเรียบร้อย");
                setTimeout(function () {
                    navigate('/generateMasterURL', {replace: true});
                }, 1500);
            }
            else {
                setLoading(false);
            }
        }).catch(err => {
            toast.error(err.message);
        });
    }

    async function exportExcelPromotion(rows) {
        let jsonData = [];
        rows.map(row => {
            let utmUrl = '';
            let campaignUrl = '';
            let adssetUrl = '';
            if(row.generateTypeUTM) {
                utmUrl = row.url + '?' + row.paramsUTM + (row.addLine ? '#addline':'');
            }
            if(row.generateTypeCampaign) {
                campaignUrl = row.paramsCampaign;
            }
            if(row.generateTypeAdsset) {
                adssetUrl = row.paramsAdsset;
            }

            let objective = campaignUrl ? campaignUrl.split('|')[2] : '-';
            let target_type = adssetUrl ? adssetUrl.split('|')[2] : '-';

            jsonData.push({
                Type: Utils.generateUTMType(row.typeId),
                Lang: row.lang,
                BuType: row.buTypeId,
                CampaignType: row.campaignTypeId,
                CampaignID: row.campaignId,
                CampaignDate: row.campaignDate ? new Date(row.campaignDate) : '',
                Objective: objective.split('_')[4],
                TargetType: target_type.split('_')[0],
                CampaignNaming: campaignUrl,
                AdsetNaming: adssetUrl,
                UTM: utmUrl,
                REBRADLY_URL: row.shortUrl ?? '',
                SHORT_IO_URL: row.shortioUrl && shortio.domain ? "https://" + shortio.domain + '/' + row.shortioUrl : '',
                CREATED_BY: roles.loginName,
                CREATED_DATE: Utils.dateYMDHI(new Date())
            });
        });
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "generate_masterurl_promotion_export_" + Utils.getDate() + ".xlsx");
    }

    //region -- Campaign
    let [campaignAdsNaming, setCampaignAdsNaming] = React.useState(null);

    let [generateGroup, setGenerateGroup] = React.useState(null);
    let [generateGroupId, setGenerateGroupId] = React.useState(null);
    let [generateGroupCampaign, setGenerateGroupCampaign] = React.useState(null);
    let [isPreviewing, setPreviewing] = React.useState(false);

    const campaignDetail = async (masterUrlForRow) => {
        const resGenerateGroup = await Utils.getGenerateGroup();
        if(resGenerateGroup) {
            setGenerateGroup(resGenerateGroup.filter(e => e.typeId === Utils.GENERATE_TYPE_MASTER_URL && e.masterUrlFor === masterUrlForRow.id));
        }

        const resAdsNaming = await Utils.getAdsNamingCampaign();
        if(masterUrlForRow.id === Utils.GENERATE_TYPE_PROJECT) {
            let newAdsNaming = resAdsNaming.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
            setCampaignAdsNaming(newAdsNaming);
        }
        else if(masterUrlForRow.id === Utils.GENERATE_TYPE_PROMOTION) {
            let newAdsNaming = resAdsNaming.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
            setCampaignAdsNaming(newAdsNaming);
        }
    };
    async function getCampaignParamsProject(n, m, param) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of generateGroupCampaign[n].items) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: param.slug,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        // --
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && generateGroupCampaign[n].adsPlatformId) {
                                platformName = platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        if(generateGroupCampaign[n]) {
            agencySlug = agency.filter(e => e.id === generateGroupCampaign[n].agencyId)[0].slug;
        }

        let params = agencySlug + '|' + param.projectId + '|' + textParams.map(x => x.text).join('_') + '_[ST]|' + (param.campaignId ? param.campaignId:'');

        return {
            params: params,
            data: textParams
        };
    }
    async function getCampaignParamsPromotion(n, m, param) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of generateGroupCampaign[n].items) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        // --
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: param.slug,
                            inputType: row.inputType
                        });
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && generateGroupCampaign[n].adsPlatformId) {
                                platformName = platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        if(generateGroupCampaign[n]) {
            agencySlug = agency.filter(e => e.id === generateGroupCampaign[n].agencyId)[0].slug;
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        let params = agencySlug + '|' + bg + '|' + textParams.map(x => x.text).join('_') + '_[ST]|' + (param.campaignId ? param.campaignId:'');

        return {
            params: params,
            data: textParams
        };
    }
    function getCampaignPreview(generateGroupCampaign) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of generateGroupCampaign.items) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: '{slugProject}',
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: '{slugPromotion}',
                            inputType: row.inputType
                        });
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && generateGroupCampaign.adsPlatformId) {
                                platformName = platform.filter(e => e.id === generateGroupCampaign.adsPlatformId)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        if(generateGroupCampaign) {
            agencySlug = agency.filter(e => e.id === generateGroupCampaign.agencyId)[0].slug;
        }

        let params = agencySlug + '|{Project ID}|' + textParams.map(x => x.text).join('_') + '_[ST]|{campaignId}';

        return params;
    }
    const onChangeGenerateGroupId = async (obj) => {
        setGenerateGroupId(null);
        setPreviewing(true);
        if(obj && obj.id) {
            setGenerateGroupId(obj);
            const generateGroupList = await Utils.getGenerateGroupCampaign(obj.id);
            if(generateGroupList) {
                for (let row of generateGroupList) {
                    if (row.master.length > 0) {
                        row.campaignPreviewParams = getCampaignPreview(row);

                        let checkAssetItem = row.master.filter(e => e.masterAdssetItems);
                        if (checkAssetItem.length > 0) {
                            for (let a of row.master) {
                                if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROJECT) {
                                    a.addsetPrevewParams = getAdssetPreviewProject(row, a);
                                }
                                else if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROMOTION) {
                                    a.addsetPrevewParams = getAdssetPreviewPromotion(row, a);
                                }
                            }
                            setGenerateTypeAdsSet(true);
                            row.masterAdssetItems = checkAssetItem;
                        }
                        let checkUtmItem = row.master.filter(e => e.masterUtmItems);
                        if (checkUtmItem.length > 0) {
                            for (let u of row.master) {
                                u.utmPrevewParams = await getUTMPreview(row, u);
                            }
                            setGenerateTypeUTM(true);
                            row.masterUtmItems = checkUtmItem;
                        }
                    }
                }

                let newGenerateGroupList = generateGroupList.filter(e => e.master.length > 0);
                setGenerateGroupCampaign(newGenerateGroupList);
                setPreviewing(false);
            }
        }
    };
    //endregion

    //region -- Ads Set
    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState(null);
    let [adssetAdsNaming, setAdssetAdsNaming] = React.useState(null);

    const adssetDetail = async (masterUrlForRow) => {
        const resSetNameType = await Utils.getAdsNamingSetNameType();
        setAdsNamingSetNameType(resSetNameType);

        const resAdssetName = await Utils.getAdsNamingSetName();
        if(resAdssetName.length > 0) {
            if(masterUrlForRow && masterUrlForRow.id ===  Utils.GENERATE_TYPE_PROJECT) {
                let newAdsNaming = resAdssetName.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
                setAdssetAdsNaming(newAdsNaming);
            }
            else if(masterUrlForRow && masterUrlForRow.id ===  Utils.GENERATE_TYPE_PROMOTION) {
                let newAdsNaming = resAdssetName.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
                setAdssetAdsNaming(newAdsNaming);
            }
        }
    };
    async function getAdssetParamsProject(n, m, idx) {
        let textParams = [];
        let sourceIds = [];
        for(let rs of generateGroupCampaign[n].masterAdssetItems[idx].masterAdssetItems) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: excelDataAll[m].lang.data + '-' + excelDataAll[m].projectType.data + '-' + excelDataAll[m].apData.slug,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        //--
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        //Fixed Slug Project
        let slugProject = textParams.length > 1 ? textParams[1].text:'';

        let platformName = '';
        if(platform && generateGroupCampaign[n].adsPlatformId) {
            platformName = '_' + platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
        }

        let adsNamingSetNameTypeText = '';
        if(generateGroupCampaign[n].masterAdssetItems[idx] && generateGroupCampaign[n].masterAdssetItems[idx].adsNamingSetNameTypeId) {
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === generateGroupCampaign[n].masterAdssetItems[idx].adsNamingSetNameTypeId)[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_' + slugProject + '|' + textParams.slice(2).map(x => x.text).join('_') + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return {
            params: params,
            data: textParams,
            //success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    async function getAdssetParamsPromotion(n, m, idx) {
        let textParams = [];
        let sourceIds = [];
        for(let rs of generateGroupCampaign[n].masterAdssetItems[idx].masterAdssetItems) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        //--
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: excelDataAll[m].apData.slug,
                            inputType: row.inputType
                        });
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        //Fixed Slug Promotion
        let slugPromotion = textParams.length > 1 ? textParams[1].text:'';

        let platformName = '';
        if(platform && generateGroupCampaign[n].adsPlatformId) {
            platformName = '_' + platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
        }

        let adsNamingSetNameTypeText = '';
        if(generateGroupCampaign[n].masterAdssetItems[idx] && generateGroupCampaign[n].masterAdssetItems[idx].adsNamingSetNameTypeId) {
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === generateGroupCampaign[n].masterAdssetItems[idx].adsNamingSetNameTypeId)[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_' + slugPromotion + '|' + textParams.slice(2).map(x => x.text).join('_') + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return {
            params: params,
            data: textParams,
            //success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    function getAdssetPreviewProject(generateGroupCampaign, adssetItem) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of adssetItem.masterAdssetItems) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        //--
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        //--
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        let platformName = '';
        if(platform && generateGroupCampaign.adsPlatformId) {
            platformName = '_' + platform.filter(e => e.id === generateGroupCampaign.adsPlatformId)[0].name;
        }

        let adsNamingSetNameTypeText = '';
        if(adssetItem && adssetItem.adsNamingSetNameTypeId) {
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === adssetItem.adsNamingSetNameTypeId)[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_{slugProject}|' + textParams.slice(1).map(x => x.text).join('_') + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return params;
    }
    function getAdssetPreviewPromotion(generateGroupCampaign, adssetItem) {
        let textParams = [];
        let sourceIds = [];

        for(let rs of adssetItem.masterAdssetItems) {
            sourceIds[rs.adsNamingId] = rs;
        }

        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map((row, index) => {
                let find = sourceIds[row.id];
                if(find) {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: row.inputType
                        });
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        //--
                    }
                    else if(row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                        //--
                    }
                    else {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.text,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        let platformName = '';
        if(platform && generateGroupCampaign.adsPlatformId) {
            platformName = '_' + platform.filter(e => e.id === generateGroupCampaign.adsPlatformId)[0].name;
        }

        let adsNamingSetNameTypeText = '';
        if(adssetItem && adssetItem.adsNamingSetNameTypeId) {
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === adssetItem.adsNamingSetNameTypeId)[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_{slugPromotion}|' + textParams.slice(1).map(x => x.text).join('_') + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return params;
    }
    //endregion

    //region -- UTM
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [hashtagList, setHashtagList] = React.useState(null);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [rebrandlyChecked, setRebrandlyChecked] = React.useState(false);
    let [shortioChecked, setShortioChecked] = React.useState(false);

    const utmDetail = async () => {
        const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
        setUtmTemplate(resTemplate);
        const resRebrandly = await Utils.getRebrandly();
        setRebrandly(resRebrandly);
        const resShortIO = await Utils.getShortIO();
        setShortIO(resShortIO);
        const resHashtag = await Utils.getHashtag();
        setHashtagList(resHashtag);
    };
    async function getUTMPreview(generateGroupCampaign, utmItem) {
        let sourceTypeIdsParam = [];
        let itemSource = utmItem.masterUtmItems;

        let templateRow = utmTemplate.filter(e => e.id === utmItem.utmTemplateId)[0];
        if(templateRow && templateRow.id) {
            const templateSource = await Utils.getTemplateSourceById(templateRow.id);
            if(templateSource) {
                const utm = await Utils.getUtmByIds(templateSource);
                if(utm) {
                    for(let row of utm) {
                        for(let rs of templateSource) {
                            let sourceType = rs.source.sourceType;
                            if(rs.source && rs.utmId === row.id) {
                                let inputType = rs.source.inputType;
                                if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                    sourceTypeIdsParam.push('x:CP' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                    sourceTypeIdsParam.push('x:CN' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                    sourceTypeIdsParam.push('x:PJI' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                    sourceTypeIdsParam.push('x:PJN' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                    sourceTypeIdsParam.push('x:PJS' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                    sourceTypeIdsParam.push('x:PMS' + rs.source.id);
                                }
                                else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                    sourceTypeIdsParam.push('x:LINEOA' + rs.source.id);
                                }
                                else {
                                    let find = sourceType.find(rs => {
                                        return itemSource.find(it => {
                                            if(parseInt(it.utmSourceTypeId) === parseInt(rs.id)) {
                                                return it;
                                            }
                                        });
                                    });
                                    if(find && find.id) {
                                        sourceTypeIdsParam.push(find.id);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let params = await Utils.generateParams({}, sourceTypeIdsParam);

        return params;
    }
    //endregion

    //region Upload
    let btnTextUploadDefault = 'อัพโหลด';
    let btnTextUploading = 'กำลังอัพโหลด..';
    let [isUploading, setUploading] = React.useState(false);
    let [isUploaded, setUploaded] = React.useState(false);
    let [excelFile, setExcelFile] = React.useState(false);
    let [excelDataAll, setExcelDataAll] = React.useState([]);
    let [excelDataError, setExcelDataError] = React.useState([]);

    const onDownload = () => {
        if(masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT) {
            onDownloadProject();
        }
        else if(masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION) {
            onDownloadPromotion();
        }
    };

    const onDownloadProject = () => {
        const a = document.createElement('a');
        a.href = DownloadTemplateProjectUrl;
        a.download = DownloadTemplateProjectUrl.split('/').pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const onDownloadPromotion = () => {
        const a = document.createElement('a');
        a.href = DownloadTemplatePromotionUrl;
        a.download = DownloadTemplatePromotionUrl.split('/').pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const resetUpload = () => {
        window.location.reload();
    };

    const onSelectFile = (e) => {
        setExcelFile(e);
    };

    const onUpload = async () => {
        if(!masterUrlForId) {
            toast.error("กรุณาระบุ Master URL For");
        }
        else if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROJECT) {
            await uploadProject();
        }
        else if(masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROMOTION) {
            await uploadPromotion();
        }
    };
    //endregion

    async function uploadProject() {
        if (excelFile && excelFile.target.value) {

            if (!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    setUploading(false);
                    setUploaded(true);
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if (data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if (cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                        }
                        else if (cols[1] !== 'Project Type') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Project Type");
                        }
                        else if (cols[2] !== 'Project Code') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Project Code");
                        }
                        else if (cols[3] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else if (cols[4] !== 'Campaign Date') {
                            setUploading(false);
                            toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign Date");
                        }
                        else if (cols[7] !== 'Master URL') {
                            setUploading(false);
                            toast.error("Column 8 : ต้องเป็น(ชื่อ) Master URL");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for (let i = 1; i < row.length; i++) {
                                let cols = row[i].split(',');
                                let colLang = cols[0].toString().trim();
                                let colProjectType = cols[1].toString().trim();
                                let colProjectCode = cols[2].toString().trim();
                                let colCampaignId = cols[3].toString().trim();
                                let colCampaignDate = Utils.dateFromExcel(cols[4].toString().trim());
                                let colMasterURL = cols[7].toString().trim();

                                let message = [];

                                //-------------------------------

                                let statusLang = false;
                                if (lang) {
                                    statusLang = lang.filter(e => e.id === colLang).length > 0;
                                }
                                if (!colLang) {
                                    message.push('Please input Lang');
                                }
                                if (!statusLang) {
                                    message.push('Invalid Lang');
                                }
                                statusError.push(statusLang);

                                //-------------------------------

                                let statusProjectType = false;
                                if (projectType) {
                                    statusProjectType = projectType.filter(e => e.id === colProjectType).length > 0;
                                }
                                if (!colProjectType) {
                                    message.push('Please input Project Type');
                                }
                                if (!statusProjectType) {
                                    message.push('Invalid Project Type');
                                }
                                statusError.push(statusProjectType);

                                //-------------------------------

                                let statusProjectCode = false;
                                let projectSlug = '';
                                let projectUrl = '';
                                let projectTitle = '';
                                let projectTypeSlug = '';
                                let projectLineOAID = '';
                                if (colLang && colProjectType) {
                                    const resProject = await Utils.getProjectCodeImport(colLang, colProjectType);
                                    if (resProject.statusCode === 200) {
                                        if (resProject && resProject.data && resProject.data.length > 0) {
                                            let projectData = resProject.data.filter(e => e.project_code === colProjectCode)[0];
                                            if (projectData) {
                                                projectTitle = projectData.project_title;
                                                projectTypeSlug = projectData.project_type_slug;
                                                projectLineOAID = projectData.line_oaid;
                                                projectSlug = projectData.project_slug;
                                                //projectUrl = projectData.project_url;
                                                statusProjectCode = projectSlug !== '';
                                            } else {
                                                message.push('API : Not found project data with {' + colProjectCode + '}');
                                            }
                                        } else {
                                            message.push('API /api/projects/urls : Not found data');
                                        }
                                    } else {
                                        message.push('API /api/projects/urls : statusCode: ' + resProject.statusCode + ', message: ' + resProject.message);
                                    }
                                }
                                statusError.push(statusProjectCode);

                                //-------------------------------

                                let statusCampaignDate = true;
                                if (colCampaignDate) {
                                    statusCampaignDate = moment(colCampaignDate, 'YYYY-MM-DD').isValid();
                                    if(!statusCampaignDate) {
                                        message.push('Invalid Campaign Date');
                                    }
                                }
                                statusError.push(statusCampaignDate);

                                //-------------------------------

                                let statusCampaignId = false;
                                let campaignName = '';
                                if (colLang && colProjectType && colProjectCode) {
                                    const resCampaign = await Utils.getCampaignImport({
                                        langId: colLang,
                                        projectType: colProjectType,
                                        projectCode: colProjectCode,
                                        campaignDate: statusCampaignDate ? colCampaignDate : null
                                    });
                                    let campaignList = [];
                                    campaignList.push({
                                        campaign_id: '0638A01',
                                        campaign_name: 'NonDefine'
                                    });
                                    if (resCampaign.statusCode === 200) {
                                        if (resCampaign.data && resCampaign.data.length > 0 && resCampaign.data[0].promotions) {
                                            for (let rs of resCampaign.data[0].promotions) {
                                                campaignList.push({
                                                    campaign_id: rs.campaign_id,
                                                    campaign_name: rs.campaign_name
                                                });
                                            }
                                            let campaignRow = campaignList.filter(e => e.campaign_id === colCampaignId)[0];
                                            if (campaignRow && campaignRow.campaign_id) {
                                                statusCampaignId = true;
                                                campaignName = campaignRow.campaign_name;
                                            } else {
                                                statusCampaignId = false;
                                                message.push('Invalid Campaign ID');
                                            }
                                        } else {
                                            message.push('API /api/projects/campaigns : Not found data');
                                        }
                                    } else {
                                        statusCampaignDate = false;
                                        message.push('API /api/projects/campaigns : statusCode: ' + resCampaign.statusCode + ', message: ' + resCampaign.message);
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                let statusMasterUrl = true;
                                let masterUrlId = null;
                                if (masterUrl && colMasterURL) {
                                    let masterUrlRow = masterUrl.filter(e => e.url === colMasterURL);
                                    statusMasterUrl = masterUrlRow.length > 0;
                                    if (statusMasterUrl) {
                                        masterUrlId = masterUrlRow[0].id
                                    }
                                    else {
                                        message.push('Invalid Master URL');
                                        message.push('{' + colMasterURL + '}');
                                    }
                                }
                                statusError.push(statusMasterUrl);

                                //-------------------------------

                                if (!statusLang || !statusProjectType || !statusProjectCode || !statusCampaignDate || !statusCampaignId || !statusMasterUrl) {
                                    excelArrError.push({
                                        lang: {
                                            data: colLang,
                                            status: statusLang,
                                        },
                                        projectType: {
                                            data: colProjectType,
                                            status: statusProjectType,
                                        },
                                        projectCode: {
                                            data: colProjectCode,
                                            status: statusProjectCode,
                                            typeSlug: projectTypeSlug,
                                            title: projectTitle,
                                            lineOAID: projectLineOAID
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        campaignDate: {
                                            data: colCampaignDate,
                                            status: statusCampaignDate
                                        },
                                        masterUrl: {
                                            data: masterUrlId,
                                            status: statusMasterUrl
                                        },
                                        apData: {
                                            url: colMasterURL,
                                            slug: projectSlug,
                                            status: true,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: colLang,
                                        status: statusLang,
                                    },
                                    projectType: {
                                        data: colProjectType,
                                        status: statusProjectType,
                                    },
                                    projectCode: {
                                        data: colProjectCode,
                                        status: statusProjectCode,
                                        typeSlug: projectTypeSlug,
                                        title: projectTitle,
                                        lineOAID: projectLineOAID
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    campaignDate: {
                                        data: colCampaignDate,
                                        status: statusCampaignDate
                                    },
                                    masterUrl: {
                                        data: masterUrlId,
                                        status: statusMasterUrl
                                    },
                                    apData: {
                                        url: colMasterURL,
                                        slug: projectSlug,
                                        status: true,
                                        message: message
                                    }
                                });
                            }

                            setExcelDataAll(excelArrAll);
                            setExcelDataError(excelArrError);
                            setGenerateTypeCampaign(statusError.every(v => v === true));
                        }
                    }
                };
                reader.readAsBinaryString(file);
            }

        } else {
            toast.error("กรุณาระบุ Excel File");
        }
    }

    async function uploadPromotion() {
        if(excelFile && excelFile.target.value) {

            if(!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if(data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                        }
                        else if(cols[1] !== 'BU Type') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) BU Type");
                        }
                        else if(cols[2] !== 'Campaign Type') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Campaign Type");
                        }
                        else if(cols[3] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else if(cols[4] !== 'Campaign Date') {
                            setUploading(false);
                            toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign Date");
                        }
                        else if (cols[7] !== 'Master URL') {
                            setUploading(false);
                            toast.error("Column 8 : ต้องเป็น(ชื่อ) Master URL");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colLang = cols[0].toString().trim();
                                let colBuType = cols[1].toString().trim();
                                let colCampaignType = cols[2].toString().trim();
                                let colCampaignId = cols[3].toString().trim();
                                let colCampaignDate = Utils.dateFromExcel(cols[4].toString().trim());
                                let colMasterURL = cols[7].toString().trim();

                                let message = [];

                                //-------------------------------

                                let statusLang = false;
                                if(lang) {
                                    statusLang = lang.filter(e => e.id === colLang).length > 0;
                                }
                                if(!colLang) {
                                    message.push('Please input Lang');
                                }
                                if(!statusLang) {
                                    message.push('Invalid Lang');
                                }
                                statusError.push(statusLang);

                                //-------------------------------

                                let statusBuType = false;
                                if(buType) {
                                    statusBuType = buType.filter(e => e.id === colBuType).length > 0;
                                }
                                if(!colBuType) {
                                    message.push('Please input BU Type');
                                }
                                if(!statusBuType) {
                                    message.push('Invalid BU Type');
                                }
                                statusError.push(statusBuType);

                                //-------------------------------

                                let statusCampaignType = false;
                                if(campaignType) {
                                    statusCampaignType = campaignType.filter(e => e.id === colCampaignType).length > 0;
                                }
                                if(!colCampaignType) {
                                    message.push('Please input Campaign Type');
                                }
                                if(!statusBuType) {
                                    message.push('Invalid Campaign Type');
                                }
                                statusError.push(statusCampaignType);

                                //-------------------------------

                                let statusCampaignDate = true;
                                if(colCampaignDate) {
                                    statusCampaignDate = moment(colCampaignDate, 'YYYY-MM-DD').isValid();
                                    if(!statusCampaignDate) {
                                        message.push('Invalid Campaign Date');
                                    }
                                }
                                statusError.push(statusCampaignDate);

                                //-------------------------------

                                let statusCampaignId = false;
                                let promotionSlug = '';
                                let promotionUrl = '';
                                let campaignName = '';
                                if(colLang && colBuType && colCampaignType) {
                                    let paramBuType = colBuType;
                                    if(colBuType === 'condo' || colBuType === 'condominium') {
                                        paramBuType = 'condo1,condo2';
                                    }
                                    const resPromotion = await Utils.getPromotionImport(colLang, colCampaignType, paramBuType, colCampaignDate);
                                    if (resPromotion.statusCode === 200) {
                                        if (resPromotion && resPromotion.data && resPromotion.data.length > 0) {
                                            let promotionData = resPromotion.data.filter(e => e.campaign_id === colCampaignId)[0];
                                            if (promotionData) {
                                                statusCampaignId = true;
                                                campaignName = promotionData.campaign_name;
                                                promotionSlug = promotionData.promotion_slug;
                                                promotionUrl = promotionData.promotion_url;
                                            } else {
                                                message.push('API : Not found promotion data with {' + colCampaignId + '}');
                                            }
                                        } else {
                                            statusCampaignId = false;
                                            message.push('API /api/promotions/urls : Not found data');
                                        }
                                    } else {
                                        statusCampaignId = false;
                                        message.push('API /api/promotions/urls : statusCode: ' + resPromotion.statusCode + ', message: ' + resPromotion.message);
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                let statusMasterUrl = true;
                                let masterUrlId = null;
                                if (masterUrl && colMasterURL) {
                                    let masterUrlRow = masterUrl.filter(e => e.url === colMasterURL);
                                    statusMasterUrl = masterUrlRow.length > 0;
                                    if (statusMasterUrl) {
                                        masterUrlId = masterUrlRow[0].id
                                    }
                                    else {
                                        message.push('Invalid Master URL');
                                    }
                                }
                                statusError.push(statusMasterUrl);

                                //-------------------------------

                                if(colBuType && colLang) {
                                    let buTypeRow = await Utils.getBuTypeView(colBuType);
                                    let buTypeCondition = buTypeRow.replace;
                                    if(colCampaignType === Utils.CAMPAIGN_TYPE_ALL) {
                                        promotionSlug = colLang + '-promotion-' +buTypeCondition + '-' + promotionSlug;
                                    }
                                    else if(colCampaignType === Utils.CAMPAIGN_TYPE_SPECIAL) {
                                        promotionSlug = colLang + '-' +buTypeCondition + '-zone-' + promotionSlug;
                                    }
                                }

                                if(!statusLang || !statusBuType || !statusCampaignType || !statusCampaignDate || !statusCampaignId || !statusMasterUrl) {
                                    excelArrError.push({
                                        lang: {
                                            data: colLang,
                                            status: statusLang,
                                        },
                                        buType: {
                                            data: colBuType,
                                            status: statusBuType,
                                        },
                                        campaignType: {
                                            data: colCampaignType,
                                            status: statusCampaignType,
                                        },
                                        projectCode: {
                                            data: null,
                                            status: null,
                                            typeSlug: null,
                                            title: null,
                                            lineOAID: null
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        campaignDate: {
                                            data: colCampaignDate,
                                            status: statusCampaignDate
                                        },
                                        masterUrl: {
                                            data: masterUrlId,
                                            status: statusMasterUrl
                                        },
                                        apData: {
                                            url : colMasterURL,
                                            slug: promotionSlug,
                                            status: true,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: colLang,
                                        status: statusLang,
                                    },
                                    buType: {
                                        data: colBuType,
                                        status: statusBuType,
                                    },
                                    campaignType: {
                                        data: colCampaignType,
                                        status: statusCampaignType,
                                    },
                                    projectCode: {
                                        data: null,
                                        status: null,
                                        typeSlug: null,
                                        title: null,
                                        lineOAID: null
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    campaignDate: {
                                        data: colCampaignDate,
                                        status: statusCampaignDate
                                    },
                                    masterUrl: {
                                        data: masterUrlId,
                                        status: statusMasterUrl
                                    },
                                    apData: {
                                        url : colMasterURL,
                                        slug: promotionSlug,
                                        status: true,
                                        message: message
                                    }
                                });
                            }

                            setExcelDataAll(excelArrAll);
                            setExcelDataError(excelArrError);
                            setGenerateTypeCampaign(statusError.every(v => v === true));
                        }
                    }
                    setUploading(false);
                    setUploaded(true);
                };
                reader.readAsBinaryString(file);
            }

        }
        else {
            toast.error("กรุณาระบุ Excel File");
        }
    }

    return (

        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Project</div>
                    <span className="ms-1">/</span> <span className="text-muted">Import</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12">
                        <button type="button" className="btn btn-sm btn-success" onClick={onDownload}><span><Icon.Download/> ดาวน์โหลดเทมเพลต</span></button>
                    </div>

                    <div className="col-12 mt-3">
                        <label htmlFor="masterURLFor" className="form-label">Master URL For <span className="text-danger">*</span></label>
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <Select
                                    classNamePrefix="form-select-search"
                                    isDisabled={isUploaded}
                                    options={masterUrlFor}
                                    onChange={(event) => onChangeMasterUrlFor(event)}
                                    value={masterUrlForId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.id} : ${option.name}`}
                                />
                            </div>
                            <div className="col-12 col-sm-6">
                                <button type="button" className="btn btn-success" onClick={onDownload} disabled={!masterUrlForId}><Icon.Download/> ดาวน์โหลดเทมเพลต</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-3">
                        <label htmlFor="generateGroupId" className="form-label">Group <span className="text-danger">*</span></label>
                        <Select
                            isDisabled={!generateTypeCampaign}
                            classNamePrefix="form-select-search"
                            options={generateGroup}
                            onChange={(event) => onChangeGenerateGroupId(event)}
                            value={generateGroupId}
                            getOptionValue={(option) => `${option.id}`}
                            getOptionLabel={(option) => `${option.name}`}
                        />
                    </div>

                    <div className="col-12 mt-3">
                        <label htmlFor="generateGroupId" className="form-label">Campaign</label>
                        <div className={"ms-2 spinner-grow spinner-grow-sm" + (isPreviewing ? '':' d-none')}></div>
                        <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                            <table className={"table table-bordered table-yellow" + (isPreviewing ? ' d-none':'')}>
                                <thead>
                                <tr>
                                    <th width="150">Name</th>
                                    <th>Format</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    generateGroupCampaign && generateGroupCampaign.length ?
                                        generateGroupCampaign.map((row, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{row.name}</td>
                                                    <td>
                                                        <div className="fw-bold mt-1">Campaign</div>
                                                        <div className="campaign-bg p-1">{row.campaignPreviewParams}</div>
                                                        <div className="fw-bold mt-1">Ads Set</div>
                                                        {
                                                            row.masterAdssetItems.map((rs, i) => {
                                                                return (
                                                                    <div className="adsset-bg p-1 mb-2">
                                                                        <span className="small fw-bold">{rs.name}</span>
                                                                        <p className="mb-0">{rs.addsetPrevewParams}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div className="fw-bold mt-1">UTM</div>
                                                        {
                                                            row.masterUtmItems.map((rs, j) => {
                                                                return (
                                                                    <div className="utm-bg p-1 mb-2">
                                                                        <span className="small fw-bold">{rs.name}</span>
                                                                        <p className="mb-0">{rs.utmPrevewParams}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={2} className="text-center">-</td></tr>
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-12 mt-3">
                        <label htmlFor="excelFilex" className="form-label">Excel File <span className="text-danger">*</span></label>
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="input-group mb-3">
                                    <input type="file" className="form-control" id="excelFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => {onSelectFile(e)}} disabled={isUploading || isUploaded} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <button type="button" className={"btn btn-success " + (isUploaded ? 'd-none':'d-block')} onClick={onUpload} disabled={isUploading}><span
                                    className={isUploading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isUploading ? btnTextUploading : btnTextUploadDefault}</button>
                                <button type="button" className={"btn btn-secondary " + (!isUploaded ? 'd-none':'d-block')} onClick={resetUpload}>เริ่มใหม่</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-2">
                        <label htmlFor="excelFilex" className="form-label">Generate Result</label>
                        <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                            {
                                masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROJECT ?
                                    <>
                                        <table className="table table-bordered table-green">
                                            <thead>
                                            <tr>
                                                <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                                <th width="100" className="text-center">Project Type <span className="text-danger">*</span></th>
                                                <th width="120" className="text-center">Project Code <span className="text-danger">*</span></th>
                                                <th width="100" className="text-center">Campaign ID</th>
                                                <th width="120" className="text-center">Campaign Date</th>
                                                <th>URL</th>
                                                <th>Project Slug</th>
                                                <th className="text-center" width="60">Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                excelDataAll.length ?
                                                    excelDataAll.map((row, index) => {
                                                        let status = row.lang.status && row.projectType.status && row.projectCode.status && row.campaignId.status && row.campaignDate.status && row.masterUrl.status;
                                                        return (
                                                            <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                                <td className={"text-center" + (!row.lang.status ? ' text-danger':'')}>{row.lang.data ?? '-'}</td>
                                                                <td className={"text-center" + (!row.projectType.status ? ' text-danger':'')}>{row.projectType.data ?? '-'}</td>
                                                                <td className={"text-center" + (!row.projectCode.status ? ' text-danger':'')}>{row.projectCode.data ?? '-'}</td>
                                                                <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                                <td className={"text-center" + (!row.campaignDate.status ? ' text-danger':'')}>{row.campaignDate.data}</td>
                                                                <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                                <td className="text-center">{row.apData.slug}</td>
                                                                <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                            </tr>
                                                        )
                                                    }) : null
                                            }
                                            {
                                                excelDataError.length === 0 && excelDataAll.length === 0 && !isUploading ? <tr><td colSpan={8} className="text-center">-</td></tr>:''
                                            }
                                            {
                                                isUploading ?  <tr><td colSpan={8} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                            }
                                            </tbody>
                                        </table>
                                    </> : ''
                            }
                            {
                                masterUrlForId && masterUrlForId.id ===  Utils.GENERATE_TYPE_PROMOTION ?
                                    <>
                                        <table className="table table-bordered table-green">
                                            <thead>
                                            <tr>
                                                <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                                <th width="100" className="text-center">BU Type <span className="text-danger">*</span></th>
                                                <th width="120" className="text-center">Campaign Type <span className="text-danger">*</span></th>
                                                <th width="100" className="text-center">Campaign ID</th>
                                                <th width="120" className="text-center">Campaign Date</th>
                                                <th>URL</th>
                                                <th>Promotion Slug</th>
                                                <th className="text-center" width="60">Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                excelDataAll.length ?
                                                    excelDataAll.map((row, index) => {
                                                        let status = row.lang.status && row.buType.status && row.campaignType.status && row.campaignId.status && row.campaignDate.status && row.masterUrl.status;
                                                        return (
                                                            <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                                <td className={"text-center" + (!row.lang.status ? ' text-danger':'')}>{row.lang.data ?? '-'}</td>
                                                                <td className={"text-center" + (!row.buType.status ? ' text-danger':'')}>{row.buType.data ?? '-'}</td>
                                                                <td className={"text-center" + (!row.campaignType.status ? ' text-danger':'')}>{row.campaignType.data ?? '-'}</td>
                                                                <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                                <td className={"text-center" + (!row.campaignDate.status ? ' text-danger':'')}>{row.campaignDate.data}</td>
                                                                <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                                <td className="text-center">{row.apData.slug}</td>
                                                                <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                            </tr>
                                                        )
                                                    }) : null
                                            }
                                            {
                                                excelDataError.length === 0 && excelDataAll.length === 0 && !isUploading ? <tr><td colSpan={8} className="text-center">-</td></tr>:''
                                            }
                                            {
                                                isUploading ?  <tr><td colSpan={8} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                            }
                                            </tbody>
                                        </table>
                                    </> : ''
                            }
                        </div>
                    </div>

                    <div className={"col-12 mt-2" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                        <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" id="rebrandlyUrl" defaultChecked={rebrandlyChecked} onChange={e => setRebrandlyChecked(e.target.checked)} />
                            <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                        </div>
                    </div>

                    <div className={"col-12 mt-2" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                        <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" name="shortioUrlChecked" id="shortioUrl" defaultChecked={shortioChecked} onChange={e => setShortioChecked(e.target.checked)} />
                            <label className="form-check-label" htmlFor="shortioUrl"></label>
                        </div>
                    </div>

                    <div className="col-12 mt-4">
                        <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading || excelDataError.length !== 0 || excelDataAll.length === 0 || !generateGroupCampaign || generateGroupCampaign.length === 0}><span
                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> <Icon.CloudArrowUp siize={16} /> {buttonText}</button>
                        <NavLink className="btn btn-sm btn-light ms-2" to='/generateProject'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                        <Toaster position="bottom-right" />
                    </div>
                </div>
            </div>
        </main>
    );
} 